import { Card, Collapse, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { http } from "../../helpers/http";
import { ChapterTitleCard } from "./ChapterTitleCard";
import { ModuleMiniCard } from "./ModuleMiniCard";
import dayjs from 'dayjs';
import moment from "moment";

type ForeignLesson = {
    lesson_counter: number;
    study_group_id: number;
    is_online: number;
    lesson_date: string;
    time_from: string;
    [key: string]: any; 
  };

export const ModulesList = (props: any) => {
    const { t } = useTranslation();
    const { self } = props;

    const [modules, setModules] = useState(undefined as any);
    const [loading, setLoading] = useState(true);
    const [studentProgress, setStudentProgress] = useState([] as any);
    const [isFirstChapter, setIsFirstChapter] = useState(false);

   // PMP2 - lv pmp group gets to do test after on site lecture starts and the rest gets the logic before 
    const isLatvian = self.language?.iso === 'lv';
    const studyGroup = self.category_study_group?.["1"];
    const isInPersonGroup = studyGroup?.study_type_id === 3;

    const [fetchedModulesForFindingCat, setFetchedModulesForFindingCat] = useState<any[]>([]);

    // const activeCategoryIds = self.studygroups
    // ?.filter((g: any) => g.active === 1)
    // .map((g: any) => g.study_group?.category_id) || [];
    const currentCategoryId = self.category?.id;

    // Vai ir only_study_group ar šo kategoriju
    const relevantGroup = self.only_study_group?.find(
    (g: any) => g.category_id === currentCategoryId
    );

    const isPmpOnline = currentCategoryId === 23 && !!relevantGroup;
    const isPmpOnlineModule = React.useMemo(() => {
        return fetchedModulesForFindingCat.some(m => m?.category_id === 23);
    }, [fetchedModulesForFindingCat]);

    console.log("isPmpOnlineModule:", isPmpOnlineModule);
   

    //const isPmp = activeCategoryIds.includes(21);
    // const isPmpOnline = activeCategoryIds.includes(23);
    // const isPmpOnlineModule = modules?.category_id === 23;


    const foreignLessons: ForeignLesson[] = props.foreignLessons || [];

    const lesson2 = React.useMemo<ForeignLesson | undefined>(() => {
        return foreignLessons.find((l: ForeignLesson) => {
          const lessonNum = Number(l.lesson_counter);
          const isOnline = Number(l.is_online);
      
          const match = lessonNum === 2 && isOnline === 0;
      
          console.log("Checking foreign lesson:", {
            lessonNum,
            isOnline,
            match,
          });
      
          return match;
        });
      }, [foreignLessons]);

    const hasLessonStarted = React.useMemo(() => {
    if (!lesson2) return false;

    const datetime = `${lesson2.lesson_date} ${lesson2.time_from}`;
    return dayjs().isAfter(dayjs(datetime, 'YYYY-MM-DD HH:mm:ss'));
    }, [lesson2]);

    const allowExam = React.useMemo(() => {
        const baseConditionsMet =
            modules?.language_chapters?.length > 0 &&
            modules.language_chapters.every((item: any) =>
                studentProgress.some((el: any) => el.hash_id === item.hash_id && el.finished === 1)
            ) &&
            studentProgress[studentProgress.length - 1]?.finished === 1;
    
        console.log("==== DEBUG EXAM ACCESS (form modules/chapters < problem screen)====");
        //console.log("isPmp:", isPmp);
        console.log("isPmpOnlineModule:", isPmpOnlineModule);
        console.log("isPmpOnline:", isPmpOnline);
        console.log("hasLessonStarted:", hasLessonStarted);
        console.log("baseConditionsMet:", baseConditionsMet);
    
        if (isPmpOnlineModule) {
            return hasLessonStarted && baseConditionsMet;
        }
    
        return baseConditionsMet;
    }, [isPmpOnlineModule, hasLessonStarted, modules, studentProgress]);


    const fetchStudentProgress = async () => {
        await http.get(`/student-chapters/${self.id}`).then((response: any) => {
            //console.log("Student chapters: ", response.data.data)
            setStudentProgress(response.data.data)
        })
    };

    const getActiveChapter = (id: any) => {
        const chapter = studentProgress.find((el: any) => el.hash_id === id);
        if (chapter === undefined) return false;
        if (chapter?.finished === 1) return false;
        if (chapter?.finished !== 1) return true;
    };

    const checkIfFirstChapter = () => {
        const chapter = modules?.language_chapters?.some((el: any) => {
            return studentProgress.some((item: any) => {
                //console.log(item, el)
                return item.hash_id === el.hash_id
            });
        });
        //console.log(chapter)
        if (chapter === undefined) {
            setIsFirstChapter(true);
        } else {
            setIsFirstChapter(!chapter);
        }
        // setIsFirstChapter(chapter === undefined || chapter === false);
    }

    const getDoneChapter = (id: any) => {
        const chapter = studentProgress.find((el: any) => el.hash_id === id)
        //console.log(studentProgress, id)
        if (chapter === undefined) return false;
        if (chapter?.finished === 1) return true;
        if (chapter?.finished !== 1) return false;
    };
    const allChaptersFinished = (mod: any) => {
    if (!mod || !Array.isArray(mod.language_chapters)) return false;

    return mod.language_chapters.every((ch: any) =>
        studentProgress.some((el: any) => el.hash_id === ch.hash_id && el.finished === 1)
    );
    }

      // Ja ir PMP Online + visi chapteri pabeigti + ir sākusies klātiene = atzīmēt moduli kā pabeigtu
        useEffect(() => {
            const autoCompleteModule = async () => {
                if (
                    isPmpOnline &&
                    hasLessonStarted &&
                    allChaptersFinished(modules) &&
                    !modules?.completed
                ) {
                    try {
                        await http.post(`/student-chapters/complete-module`, {
                            module_id: modules.hash_id,
                            student_id: self.id,
                        });
                        fetchStudentProgress(); // atjauno statusu pēc atzīmēšanas
                    } catch (err) {
                        console.error("Failed to auto-complete module:", err);
                    }
                }
            };
        
            if (modules) {
                autoCompleteModule();
            }
        }, [isPmpOnline, hasLessonStarted, studentProgress, modules]);

    useEffect(() => {
        fetchStudentProgress();
    }, [])

    useEffect(() => {
        const fetchModules = async () => {
            try {
                const res = await http.get(`/student-modules/${self.id}`);
                const modulesData = res.data.data || [];

                // ONLY for logging cat id 
                console.log("active module data from the prob screen fetchmodules:", modulesData);
                setFetchedModulesForFindingCat(modulesData);

            } catch (err) {
                console.error("Failed to fetch student modules", err);
            }
        };

        fetchModules();
    }, [self.id]);

    useEffect(() => {   // yeah... dont f with this
        if (props.active) {
            setModules(props.modules())
            console.log(setModules)
        } else {
            setModules(props.modules)
            console.log(setModules)
        }
    }, [props.modules]);

    useEffect(() => {
        console.log(modules)
        if (modules !== undefined) {
            setLoading(false)
        }
    }, [modules]);

    useEffect(() => {
        if (modules !== undefined) {
            checkIfFirstChapter();
        }
    }, [studentProgress, modules])

    useEffect(() => {
        console.log("==== DEBUG EXAM ACCESS (group and lesson start FROM USE EFFECT)====");
       // console.log("isPmp:", isPmp);
        console.log("isPmpOnline:", isPmpOnline);
        console.log("isPMPOnline in module?", isPmpOnlineModule);
        console.log("hasLessonStarted:", hasLessonStarted);
    }, [isPmpOnlineModule, hasLessonStarted]);

    return loading
        ? <Skeleton />
        : modules?.length > 0 || typeof modules === "object"
            ? props.active
                ? <Collapse
                    defaultActiveKey={['1']}
                    className="e-learning-card"
                    expandIcon={() => <></>}
                >
                    <Collapse.Panel
                        header={<ModuleMiniCard ind={modules.ind} module={modules} active />}
                        key={1}
                    >
                        {
                            modules.failed_exam
                                ? <></>
                                : modules.language_chapters.map((chapter: any, index: any) => {
                                    //console.log(chapter)
                                    const done = getDoneChapter(chapter.hash_id);
                                    const active = getActiveChapter(chapter.hash_id);
                                    const next = (isFirstChapter && index === 0)
                                        || (studentProgress[studentProgress.length - 1]?.hash_id === modules.language_chapters[index - 1]?.hash_id
                                            && studentProgress[studentProgress.length - 1]?.finished === 1)
                                    //console.log(next)
                                    return <ChapterTitleCard
                                        key={index}
                                        chapter={chapter}
                                        module={modules}
                                        categoryId={self.category_id}
                                        active={active}
                                        done={done}
                                        next={next}
                                    />
                                })
                        }
                        {/* {
                            modules.failed_exam || modules.exam_questions_count === 0
                                ? <></>
                                : <ChapterTitleCard
                                    exam
                                    moduleID={modules.hash_id}
                                    next={modules.language_chapters.length === modules.language_chapters.filter((item: any) => {
                                        return studentProgress.some((el: any) => (el.hash_id === item.hash_id) && el.finished === 1)
                                    }).length
                                        && studentProgress[studentProgress.length - 1]?.finished === 1}
                                />
                        } */}
                        {
                            modules.failed_exam || modules.exam_questions_count === 0 ? null : (
                                <>
                                {console.log("==== DEBUG EXAM ACCESS from title====")}
                                {console.log("hasLessonStarted:", hasLessonStarted)}
                                {console.log("allChaptersFinished:", modules.language_chapters.length === modules.language_chapters.filter((item: any) =>
                                  studentProgress.some((el: any) => el.hash_id === item.hash_id && el.finished === 1)
                                ).length)}
                                {console.log("allowExam:", allowExam)}
                                <ChapterTitleCard
                                exam={true}
                                moduleID={modules.hash_id}
                                next={
                                    allowExam &&
                                    modules.language_chapters.length === modules.language_chapters.filter((item: any) =>
                                    studentProgress.some((el: any) => el.hash_id === item.hash_id && el.finished === 1)
                                    ).length &&
                                    studentProgress[studentProgress.length - 1]?.finished === 1
                                }
                                disabled={!allowExam}
                                isPmpOnlineModule={isPmpOnlineModule} 
                                />
                                </>
                            )
                            }

                    </Collapse.Panel>
                </Collapse>
                : props.doneChapters
                    ? modules.map((module: any, index: any) => {
                        return <Collapse
                            key={index}
                            className="e-learning-card"
                            expandIcon={() => <></>}
                        >
                            <Collapse.Panel
                                header={
                                    <ModuleMiniCard
                                        ind={module.ind}
                                        module={module}
                                        done={props.done}
                                    />
                                }
                                key={index}
                                style={{
                                    boxShadow: '0 3px 6px 0 rgba(64,96,128,0.1)',
                                    borderRadius: '2px',
                                    marginBottom: '4px'
                                }}
                            >
                                {
                                    module.language_chapters?.map((chapter: any, index: any) => {
                                        return <ChapterTitleCard
                                            key={index}
                                            chapter={chapter}
                                            categoryId={self.category_id}
                                            // active={active}
                                            module={module}
                                            done={true}
                                        // next={next}
                                        />
                                    })
                                }
                            </Collapse.Panel>
                        </Collapse>
                    })
                    : modules.map((module: any, index: any) => {
                        return <Card
                            className="e-learning-card"
                            key={index}
                        >
                            <ModuleMiniCard
                                ind={module.ind}
                                module={module}
                            // done={props.done}
                            />
                        </Card>
                    })
            : <b>{t('e_learning.no_available_modules')}</b>
}